import { render, staticRenderFns } from "./DepartAuthModal.vue?vue&type=template&id=e765cc30&scoped=true"
import script from "./DepartAuthModal.vue?vue&type=script&lang=js"
export * from "./DepartAuthModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e765cc30",
  null
  
)

export default component.exports